import { createSlice } from '@reduxjs/toolkit';
import config from 'config';

const initialState = {
  ...config
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setContainer(state, action) {
      state.container = action.payload;
    },
    setMode(state, action) {
      state.mode = action.payload;
    },
    setPresetColor(state, action) {
      state.presetColor = action.payload;
    },
    setThemeDirection(state, action) {
      state.themeDirection = action.payload;
    },
    setMenuOrientation(state, action) {
      state.menuOrientation = action.payload;
    },
    setFontFamily(state, action) {
      state.fontFamily = action.payload;
    },
    setBreadcrumbs(state, action) {
      state.breadcrumbs = action.payload;
    }
  }
});

export const { setContainer, setMode, setPresetColor, setThemeDirection, setMenuOrientation, setFontFamily, setBreadcrumbs } =
  configSlice.actions;

export default configSlice.reducer;
